import modalConfirmation from '../modal-response/modal-response.view.html';
let inject = ['$scope', '$timeout', '$uibModalInstance', 'modalOptions', 'SharedService', 'SessionService', '$state', '$uibModal','CartService'];

class ModalSelectModalidadController {
    constructor($scope, $timeout, $uibModalInstance, modalOptions, SharedService, SessionService, $state, $uibModal,CartService) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.SharedService = SharedService;
        this.$state = $state;
        this.SessionService = SessionService;
        this.$uibModalInstance = $uibModalInstance;
        this.$uibModal = $uibModal;
        this.modalOptions = Object.assign({}, modalOptions);
        this.state = {};
        this.branchUserB2B = {};
        this.registerDataForm = {};
        this.CartService = CartService;
    }


    setModalidadPago(modalidadId, tipoModalidad) {

        this.state.saving = true;
        let data = '';
        let cartId = '';
        let mesaggeChange = '';
        let servicioDescargue = this.registerDataForm.servicioDescargue;
        let transportePropio = this.registerDataForm.transportePropio;
        let trasnporteUltracem = this.registerDataForm.gestionadoUltracem;
        let currentClient = this.SessionService.get('currentClient');
        let sucursalId = currentClient.operatingCenter.id;
        let allMessage = [];
        try {
            cartId = this.modalOptions.modalidadesPago.cartId;
            mesaggeChange = this.modalOptions.cmsMessage.MENSAJE_CAMBIO_SUCURSAL;
            data = {
                'modalidadId': modalidadId,
                'cartId': cartId,
                'servicioDescargue': servicioDescargue,
                'transportePropio': transportePropio,
                'trasnporteUltracem': trasnporteUltracem,
            };
        } catch (e) {
        }

        if (tipoModalidad == 0) {
            if (sucursalId != null) {
                this.CartService.verifyBranchLock(sucursalId).then(response => {
                    if (!response.error) {
                         // Si es opl
                        if (response.principal) {
                            if (response.bloqueoSucursal) {
                                this.state.saving = false;
                                this.state.saved = true;
                                this.modalidadRecoge = false;
                                let message = this.modalOptions.cmsMessage.B2B_MENSAJE_INFORMATIVO_BLOQUEO_RETIRO;
                                allMessage.push(message);
                                this.showModalMessageBlock(allMessage);
                            } else {
                                this.updateModalidadPago(data);
                            }
                        }else{
                            if (response.bloqueoSucursal) {
                                this.state.saving = false;
                                this.state.saved = true;
                                this.modalidadRecoge = false;

                                let message = this.modalOptions.cmsMessage.B2B_MENSAJE_INFORMATIVO_BLOQUEO_RETIRO;
                                allMessage.push(message);
                                let validacionRetiroMensaje = this.CartService.ngAuthSettings.site.info.company.validacionRetiroTiendaMensaje;

                                if (validacionRetiroMensaje) {
                                    let cartId = this.modalOptions.modalidadesPago.cartId;
                                    let userId = this.modalOptions.userData.currentUser.userId;
                                    this.CartService.getMaximumMainVolume(cartId, userId).then(responseMaximun => {
                                      if(!responseMaximun.error){
                                        if(responseMaximun.contienePrincipal){
                                          let messageRetiro = this.modalOptions.cmsMessage.B2B_MENSAJE_MOSTRAR_CANTIDAD_MAXIMA_OPL;
                                          messageRetiro = messageRetiro.replace("#capacidad_maxima_bodega_anterior#", responseMaximun.pesoMaximoBodega)
                                          allMessage.push(messageRetiro);
                                          this.showModalMessageBlock(allMessage);
                                        }else{
                                          this.showModalMessageBlock(allMessage);
                                        }
                                      }
                                    });
                                } else {
                                    this.showModalMessageBlock(allMessage);
                                }

                            } else {
                                this.updateModalidadPago(data);
                            }
                        }
                    }
                });
            }
        } else {
            if(servicioDescargue){
                if(cartId != null){
                    this.CartService.verifyUnloadingService(cartId).then(response => {
                        if (!response.error) {

                            if (response.permiteDescargue) {
                                this.updateModalidadPago(data);
                            } else {
                                this.registerDataForm.servicioDescargue = false;
                                this.state.saving = false;
                                this.state.saved = true;
                                this.modalidadRecoge = false;
                                let message = this.modalOptions.cmsMessage.B2B_MENSAJE_INFORMATIVO_SUCURSAL_NO_HABILITA_DESCARGUE;
                                let options = {
                                    title: 'No es posible continuar con el pedido...',
                                    isHtml: true,
                                    content: message,
                                    size: '',
                                    showBottonCancel: false,
                                    textActionCancel: '',
                                    textAction: 'Aceptar'
                                };
                                this.messageResponse(options);
                            }
                        }
                    });
                }
            } else{
                this.updateModalidadPago(data);
            }
        }
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

    ok() {
        this.$uibModalInstance.close(this.$scope);
    }

    updateModalidadPago(data){
        this.SharedService.setModalidadPago(data).then(response => {
            this.state.saving = false;
            this.state.saved = true;
            if (!response.error) {
                // Set the current client
                try {
                    this.state.saving = false;
                    this.state.saved = true;
                } catch (e) {
                    // console.log(e);
                    this.state.saving = false;
                    this.state.error = true;
                }
                this.ok();
            } else {
                this.state.error = true;
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
          animation: true,
          template: modalConfirmation,
          controller: 'ModalResponseController',
          controllerAs: 'mdCtrl',
          size: options.size,
          resolve: {
            modalOptions: () => options
          }
        });
        modalInstance.result.then(() => {
          if (callAcept) {
            callback();
          }
        }).catch(reason => {
          if (callCancel) {
            callbackCancel();
          }
        });
      }

      showModalMessageBlock(allMesagge) {
        let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

        for (let i = 0; i < allMesagge.length; i++) {
          contentDynamic += `
                                <ul><li>` + allMesagge[i] + `</li></ul>`;
        }

        if (contentDynamic != '') {
          let optionsMessage = {
            title: 'No es posible continuar con el pedido',
            isHtml: true,
            content: contentDynamic,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar',
            backdrop: 'static'
          };

          let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: 'md',
            backdrop: 'static',
            resolve: {
              modalOptions: () => optionsMessage
            }
          });
          modalInstance.result.then(() => {
          }).catch(() => {

          });
        }
      }
}

ModalSelectModalidadController.$inject = inject;

export default ModalSelectModalidadController;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/modal-select-modalidad-pago/modal-select-modalidad-pago.js
 **/